module.exports = __webpack_public_path__ + "static/media/S.76065f15.jpg";